import React from 'react';
import PropTypes from 'prop-types';

import Modal, { TYPES } from '@glu/modal-react';

import useLocale from 'components/useLocale';
import { DEFAULT_PROPS } from 'constants.js';

import PromptContent from './PromptContent';

const { EMPTY_FUNCTION } = DEFAULT_PROPS;

export const PromptComponent = ({ onCancel = EMPTY_FUNCTION, onConfirm = EMPTY_FUNCTION }) => {
  const locale = useLocale();

  return (
    <Modal
      ariaLabelledby="modalHeader"
      closeOnClickAway
      dataQa="route-guard-modal"
      header={locale['common.leavePage']}
      onClose={onCancel}
      open
      type={TYPES.ERROR}
    >
      <PromptContent onCancel={onCancel} onConfirm={onConfirm} />
    </Modal>
  );
};

PromptComponent.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
};

export default PromptComponent;
